/** Applicant endpoints — profile, access requests, job matches, resume. */
import client from './client';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const applicantAPI = {
  createProfile: async (data) => (await client.post('/applicants/profile', data)).data,
  getProfile: async () => (await client.get('/applicants/profile')).data,
  updateProfile: async (data) => (await client.put('/applicants/profile', data)).data,
  getAccessRequests: async () => (await client.get('/applicants/requests')).data,
  respondToRequest: async (id, action) => (await client.post(`/access-requests/${id}/respond`, { action })).data,
  getResumePdfUrl: () => {
    const token = localStorage.getItem('auth_token');
    return API_URL + '/applicants/resume/pdf' + (token ? '?token=' + encodeURIComponent(token) : '');
  },
  getJobMatches: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    return (await client.get(`/applicants/job-matches?${q.toString()}`)).data;
  },
  respondToJobMatch: async (id, action) => (await client.post(`/applicants/job-matches/${id}/respond`, { action })).data,
  getReferral: async () => (await client.get('/applicant/referral')).data,
};

export default applicantAPI;
